function u(e) {
  "@babel/helpers - typeof";
  return u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, u(e);
}
function m(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function p(e, t) {
  for (var i = 0; i < t.length; i++) {
    var o = t[i];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, b(o.key), o);
  }
}
function g(e, t, i) {
  return t && p(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function y(e, t, i) {
  return t = b(t), t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function b(e) {
  var t = w(e, "string");
  return u(t) == "symbol" ? t : t + "";
}
function w(e, t) {
  if (u(e) != "object" || !e) return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var o = i.call(e, t);
    if (u(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var x = /* @__PURE__ */ function() {
  function e() {
    m(this, e), y(this, "activeIndex", 0), y(this, "coordinateList", []), y(this, "layout", "horizontal");
  }
  return g(e, [{
    key: "setDetails",
    value: function(i) {
      var o, n = i.coordinateList, a = n === void 0 ? null : n, c = i.container, r = c === void 0 ? null : c, f = i.layout, l = f === void 0 ? null : f, h = i.offset, s = h === void 0 ? null : h, v = i.mouseHandlerCallback, d = v === void 0 ? null : v;
      this.coordinateList = (o = a ?? this.coordinateList) !== null && o !== void 0 ? o : [], this.container = r ?? this.container, this.layout = l ?? this.layout, this.offset = s ?? this.offset, this.mouseHandlerCallback = d ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(i) {
      if (this.coordinateList.length !== 0)
        switch (i.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(i) {
      this.activeIndex = i;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var i, o;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var n = this.container.getBoundingClientRect(), a = n.x, c = n.y, r = n.height, f = this.coordinateList[this.activeIndex].coordinate, l = ((i = window) === null || i === void 0 ? void 0 : i.scrollX) || 0, h = ((o = window) === null || o === void 0 ? void 0 : o.scrollY) || 0, s = a + f + l, v = c + this.offset.top + r / 2 + h;
        this.mouseHandlerCallback({
          pageX: s,
          pageY: v
        });
      }
    }
  }]);
}();
export {
  x as AccessibilityManager
};
